import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import userService from "../../services/userService";
import BackgroundForm from "../forms/pageForms/backgroundForm";
import TaskComplete from "../common/taskComplete";
import { Button } from "react-bootstrap";
import {
  Modal,
  ModalTitle,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "react-bootstrap";
import SaveAndContinueUserMessage from "../common/userMessages/saveAndContinueMessage";
export default function BackgroundInformation({
  user,
  userData,
  shake,
  updatePage,
  enablePhases,
  allTasksCompleted,
}) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [modalShow, setModalShow] = useState(false);

  const onModalHide = () => {
    setModalShow(false);
    updatePage();
  };

  const handleFormikSubmit = async (values) => {
    Object.keys(values).forEach((key) => {
      if (values[key] === "" || !values[key]) {
        delete values[key];
      }
    });

    if (!allTasksCompleted) {
      setModalShow(true);
      await userService.saveUserData(user, "backgroundInfo", values);
      userData.backgroundInfo = values;
    } else {
      updatePage();
      navigate("../phase3-submit-application");
      await userService.saveUserData(user, "backgroundInfo", values);
      userData.backgroundInfo = values;
    }
  };

  useEffect(() => {}, []);

  return (
    <>
      {/* {userData.backgroundInfo ? (
        <section className="main-section">
          <h2>Background Information</h2>
          <section className="main-section-content">
            <TaskComplete
              pageTitle="Background Information"
              nextLink={enablePhases.phase3 ? "phase3-submit-application" : ""}
            />
          </section>
        </section>
      ) : (
        <> */}
          <Modal show={modalShow} centered>
            {" "}
            <ModalHeader as="span" className="alert alert-warning">
              <ModalTitle as="h4">{t("background.incompleteTasksTitle")}</ModalTitle>
            </ModalHeader>
            <ModalBody as="section">
              {t("background.incompleteTasksBody")}
            </ModalBody>
            <ModalFooter as="footer">
              <Button variant="outline-primary" onClick={onModalHide}>{t("background.confirm")}</Button>
            </ModalFooter>
          </Modal>
          {/* Page Instructions  */}
          <section className="main-section">
            <h2>{t("background.title")}</h2>
            <section className="main-section-content text-start">
              <p>{t("background.intro1")}</p>
              <p>{t("background.intro2")}</p>
              <p>{t("background.intro3")}</p>
              <p className="alert alert-info">
                {t("background.pageRequirements")}
              </p>
            </section>
          </section>
          {/* Form Section */}
          <section className="main-section">
            <section className="main-section-content">
              <BackgroundForm
                // handleSaveAndContinue={handleSaveAndContinue}
                shake={shake}
                handleFormikSubmit={handleFormikSubmit}
                updatePage={updatePage}
                userData={userData}
                // showReqFieldMessage={showReqFieldMessage}
              />
            </section>
          </section>
        {/* </>
      )} */}
    </>
  );
}
